import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Spinner,
  buttonVariants,
  cn,
} from '@vivicta/ui';

import { useSignOut } from './useSignOut';

/**
 * Confirmation body shared by every sign-out entry point (the Settings page
 * button, the top-bar avatar menu). Must be rendered inside an `AlertDialog`
 * owned by the caller — this only supplies the content.
 */
export const SignOutConfirmDialog = () => {
  const { signOut, pending, error } = useSignOut();

  return (
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Sign out of the portal?</AlertDialogTitle>
        <AlertDialogDescription>
          Your session will end and you will be returned to the sign-in page.
          Anything you have not submitted will be lost.
        </AlertDialogDescription>
      </AlertDialogHeader>
      {error && (
        <p role="alert" className="text-sm text-destructive-strong">
          {error}
        </p>
      )}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={pending}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          /* Not a close-on-select action — signing out redirects the page. */
          onClick={event => {
            event.preventDefault();
            void signOut();
          }}
          disabled={pending}
          className={cn(buttonVariants({ variant: 'destructive' }))}
        >
          {pending && <Spinner size={16} />}
          Sign out
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
};
